module.exports = __webpack_public_path__ + "static/media/logo.409d3d40.png";